import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {
    selectArticleCode,
    selectCRI,
    selectDiameter,
    selectSystemLumen,
    selectSystemLumenPerPower,
    selectSystemPower,
    selectZhaga
} from '../../../selectors';

@customElement('visual-test')
export class VisualTest extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		position: absolute;
		top: 50%;
		right: 20px;
		display: flex;
		flex-direction: column;
		color: #666;
		width: 50%
	  }

	  .loading {
		opacity: 0.5;
	  }

	  dl {
		font: var(--font-light)
	  }

	  dt {
		float: left;
		display: block;
		width: 170px;
	  }

	  dd {
		display: block;
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.price = state.price;
	}
	render() {
		const s = this.state;
		return html`
			<dl>
				<dt>Code</dt>
				<dd>${selectArticleCode(s)}</dd>

				<dt><trans-label key="LU_SystemLuminousFlux" context="D"></trans-label></dt>
				<dd>${selectSystemLumen(s)} lm</dd>

				<dt><trans-label key="LU_Efficacy" context="D"></trans-label></dt>
				<dd>${selectSystemLumenPerPower(s)} m/W</dd>

				<dt><trans-label key="HS_HousingDiameter" context="D"></trans-label></dt>
				<dd>${selectDiameter(s)} mm</dd>

				<dt><trans-label key="LE_CRI" context="D"></trans-label></dt>
				<dd>${selectCRI(s)}</dd>

				<dt class="${classMap({loading: this.price.status === 'loading'})}">Price</dt>
				<dd>${this.price.data.totalPriceInEuro} €</dd>
			</dl>
		`;
	}
}
